/**
 * Handles play/pause functionality for a video player.
 * Toggles video playback and updates button label and accessibility text.
 *
 * @param {HTMLElement} videoWrapper - The wrapper element containing the video and controls.
 */
export const videoPlayerHandle = (videoWrapper) => {
  const videoElement = videoWrapper.querySelector('video');
  const videoPlayer = videoWrapper.querySelector('button');
  const hiddenElement = videoWrapper.querySelector('span.visually-hidden');

  if (!videoElement || !videoPlayer) {
    return console.error('There was no video element found');
  }

  videoPlayer.addEventListener('click', function (e) {
    if (e.target.ariaLabel === 'Pause video') {
      videoElement.pause();
      videoPlayer.ariaLabel = 'Play video';
      hiddenElement.textContent = 'Play';
    } else {
      videoElement.play();
      videoPlayer.ariaLabel = 'Pause video';
      hiddenElement.textContent = 'Pause';
    }
  });
};
